<template>
    <div>
        <h2>{{ $t("invoice.control_properties_actes") }}</h2>
        <div class="box">
            <p>{{ $t("invoice.control_properties_texte") }}</p>
            <CustomTable
                id_table="control_properties"
                :dateFilter="date_filter"
                :periodToShow="['personalise', 'mois_dernier', 'mois']"
                @dateRangeSubmit="init_component"
                :items="properties"
                :busy.sync="table_busy"
                primaryKey="horse_id"
                :hide_if_empty="true"
                :hrefsRoutes="config_table_hrefs"
            >
            </CustomTable>
        </div>
    </div>
</template>


<script type="text/javascript">
    import Invoice from "@/mixins/Invoice.js"

    export default {
        name: "controlPropertiesActes",
        mixins: [Invoice],
        data () {
            return {
                date_filter: {
                    start: new Date(new Date().setMonth(new Date().getMonth() - 1)),
                    end: new Date(),
                    periodLabel: 'mois'
                },
                properties: [],
                table_busy: true,
                config_table_hrefs: {
                    'horse_nom': {
                        routeUniqueName: 'horseFiche',
                        routeName: 'horseFiche',
                        params: {
                            horse_id: 'horse_id'
                        }
                    }
                }
            }
        },
        methods: {
            async init_component() {
                this.table_busy = true
                const properties = await this.controlProperties(this.date_filter.start.toDateInputValue(), this.date_filter.end.toDateInputValue())
                this.properties = properties.actes.concat(properties.pension)
                this.table_busy = false
            }
        },
        components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable')
        }
    }
</script>
